import * as React from "react";

import BaseProductCategoryListLayout from "./BaseProductCategoryListLayout";

export default function (params) {
  return BaseProductCategoryListLayout();
}
